(function() {
  'use strict';

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var fmt = (window.theme && window.theme.moneyFormat) || '₹{{amount}}';
      return window.Shopify.formatMoney(cents, fmt);
    }
    return 'Rs. ' + (cents / 100).toFixed(2);
  }

  function initFBT(wrapper) {
    if (wrapper.dataset.fbtInit === 'true') return;
    wrapper.dataset.fbtInit = 'true';

    var checks = wrapper.querySelectorAll('.fbt-zira__check');
    // First product checked, others unchecked
    checks.forEach(function(cb, index) {
      cb.checked = index === 0;
    });

    var totalOldEl = wrapper.querySelector('.fbt-zira__total-old');
    var totalNewEl = wrapper.querySelector('.fbt-zira__total-new');
    var btn = wrapper.querySelector('.fbt-zira__btn');
    var originalText = btn ? btn.textContent.trim() : 'Add all to cart';

    // FIX: hide/show each row's own strikethrough price, not just the total.
    // A row where compare <= price is not a real discount and must not show
    // a struck-through price at all.
    function fixRowPrices() {
      checks.forEach(function(cb) {
        var compare = parseInt(cb.dataset.compare, 10) || 0;
        var price = parseInt(cb.dataset.price, 10) || 0;

        // find this row's own compare-price element
        var row = cb.closest('.fbt-zira__item') || cb.closest('li') || cb.parentElement;
        if (!row) return;
        var rowCompareEl = row.querySelector('.fbt-zira__compare, [data-role="compare-price"]');
        if (!rowCompareEl) return;

        if (compare > price) {
          rowCompareEl.textContent = formatMoney(compare);
          rowCompareEl.style.display = 'inline';
        } else {
          // no real discount on this item — don't show a fake strikethrough
          rowCompareEl.style.display = 'none';
        }
      });
    }

    function updateTotal() {
      var totalOld = 0;
      var totalNew = 0;

      checks.forEach(function(cb) {
        if (cb.checked) {
          var compare = parseInt(cb.dataset.compare, 10) || 0;
          var price = parseInt(cb.dataset.price, 10) || 0;

          // FIX: only count compare price if it's actually higher than price.
          // Previously totalOld always added data-compare even when it equaled
          // or was less than data-price, which could understate savings or
          // (if compare < price somewhere) make totals inconsistent.
          totalOld += Math.max(compare, price);
          totalNew += price;
        }
      });

      var savings = totalOld - totalNew;

      if (totalNewEl) totalNewEl.textContent = formatMoney(totalNew);

      if (totalOldEl) {
        if (savings > 0) {
          totalOldEl.textContent = formatMoney(totalOld);
          totalOldEl.style.display = 'inline';
        } else {
          totalOldEl.style.display = 'none';
        }
      }
    }

    checks.forEach(function(cb) {
      cb.addEventListener('change', updateTotal);
    });

    if (btn) {
      btn.addEventListener('click', function() {
        var items = [];
        checks.forEach(function(cb) {
          if (cb.checked && cb.dataset.variantId) {
            items.push({
              id: parseInt(cb.dataset.variantId, 10),
              quantity: 1
            });
          }
        });

        if (items.length === 0) {
          alert('Please select at least one product');
          return;
        }

        btn.disabled = true;
        btn.textContent = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: items })
        })
        .then(function(res) { return res.json(); })
        .then(function(data) {
          if (data.status) {
            alert(data.description || 'Error adding to cart');
            btn.disabled = false;
            btn.textContent = originalText;
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function(err) {
          console.error('FBT Error:', err);
          alert('Could not add to cart. Please try again.');
          btn.disabled = false;
          btn.textContent = originalText;
        });
      });
    }

    fixRowPrices();
    updateTotal();
  }

  function initAll() {
    document.querySelectorAll('.fbt-zira').forEach(initFBT);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:block:select', initAll);

})();